// extracted by mini-css-extract-plugin
module.exports = {"Save":"ChangeDeadline_Save__2SZqS","Form":"ChangeDeadline_Form__3TRES","FromNow":"ChangeDeadline_FromNow__3Ruo0","DeadlineLabel":"ChangeDeadline_DeadlineLabel__3nByY"};